export const APP_CONFIG = {
  /**
   * Current environment
   * Options: 'Dev', 'UAT'
   */
  ENVIRONMENT: 'Dev',

  /**
   * Application version
   * Format: vX.Y.Z (e.g., v1.0.3)
   */
  VERSION: 'v1.1.24',
} as const;

export const ENVIRONMENT_COLORS = {
  uat: '#ff9800', // Orange
  dev: '#9e9e9e', // Gray
} as const;

// Type definitions for better TypeScript support
export type Environment = 'Dev' | 'UAT';
export type EnvironmentColorKey = keyof typeof ENVIRONMENT_COLORS;
